export default {
	INFO: 'info',
	WARNING: 'warning',
	SUCCESS: 'success',
	ERROR: 'error'
};
